<template>
  <div class="form-group">
    <multiselect v-model="selectedRequirements"
                 :options="requirements"
                 :multiple="true"
                 :custom-label="customRequirementLabel"
                 :close-on-select="true"
                 :clear-on-select="false"
                 :hide-selected="true"
                 placeholder="Link requirements to content"
                 track-by="requirement_id">
    </multiselect>
  </div>
</template>

<script>
  import dialogMixin from '@/mixins/dialog'
  import requirementModalMixin from '@/mixins/requirementModal'
  import utilsMixin from '@/mixins/utils'
  export default {
    data () {
      return {
        requirements: [],
        selectedRequirements: [],
        contentId: null
      }
    },
    created () {
      this.getContext()
      this.bindButton()
    },
    mixins: [dialogMixin, requirementModalMixin, utilsMixin],
    methods: {
      bindButton () {
        window.AP.require(['confluence', 'dialog'], (confluence, dialog) => {
          dialog.getButton('submit').bind(target => {
            this.$http.put(
              `/api/confluence/content/${this.contentId}`,
              {
                requirements: this.selectedRequirements
              }
            )
            confluence.saveMacro({})
            confluence.closeMacroEditor()
            return true
          })
        })
      },
      getLinkedRequirements () {
        this.$http.get(
          `/api/requirement/lite?atlassian_content_id=${this.contentId}`,
        ).then(response => {
          this.selectedRequirements = response.data.requirements
        }, response => {
          console.log('error')
        })
      },
      getRequirements () {
        this.$http.get(
          '/api/requirement/lite'
        ).then(response => {
          this.requirements = response.data.requirements
          this.getLinkedRequirements()
        }, response => {
          console.log('error')
        })
      },
      getContext () {
        window.AP.navigator.getLocation(location => {
          this.contentId = location.context.contentId
          this.getRequirements()
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ConfluenceLinkedRequirementsMacroEditorView.vue?399be5ef